import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import apiClient from "../../../../services/api";
import store from '../../../../store';
import { toggleMessageOpen } from '../../../../store/actions/Message';
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import { getSelectedObject } from "../helpers";
import { ContentPasteOffSharp } from "@mui/icons-material";

import { setReference } from "../../../../store/shortcuts/Project";

export default function ProductsBackgroundsTab() {
    const { id } = useParams();
    const { t } = useTranslation();
    const theme = useTheme();

    const selectedProject = useSelector((state) => state.project.selectedProject);
    const stateBackgrounds = useSelector((state) => state.backgrounds.backgrounds);
    const selectedMeshId = useSelector((state) => state.project.selectedMeshId);
    const selectedMesh = useSelector((state) => state.project.selectedMesh);
    const projectElements = useSelector((state) => state.project.elements);

    const [project, setProject] = useState(null);
    const [backgrounds, setBackgrounds] = useState(null);
    const [customerNumber, setCustomerNumber] = useState(null);
    const [textures, setTextures] = useState(null);
const [objects, setObjects] = useState(null);
    const [selectedBackground, setSelectedBackground] = useState(null);
    const [selectedTexture, setSelectedTexture] = useState(null);

    const previewBoxHeight = 70;
    const previewBoxMargin = 5;
    const storagePath = process.env.REACT_APP_BASE_URL + '/storage';
    const imageBasePath = storagePath + '/' + customerNumber + '/' + id + '/gltfs/';

    useEffect(() => {
        setTextures(null);
	setObjects(null);
        setSelectedTexture(null);
    }, [])

    useEffect(() => {
        if (selectedProject) {
            setProject(selectedProject.project);
        }

        if (stateBackgrounds) {
            setBackgrounds(stateBackgrounds);
            setSelectedBackground(stateBackgrounds[0]);
        }
    }, [selectedProject, stateBackgrounds]);

    useEffect(() => {
        if (!selectedMesh) {
            return;
        }

        const selectedObject = getSelectedObject(projectElements, selectedMeshId);

        if(!selectedObject?.is_product) {
            setTextures(null);
            setSelectedTexture(null);
		setObjects(null);

            return;
        }
        
        apiClient.post(
            '/api/objects/load-category-related-objects',
            {
                object_id: selectedObject?.object_id,
                project_id: selectedProject?.id,
            }
        ).then((response) => {
            if (!response.data.success) {
                return;
            }

            setTextures(response.data.images);
            setObjects(response.data.objects);
        }).catch(error => {
            store.dispatch(toggleMessageOpen(t('An error occurred while retrieving project textures'), 'error'));
        });
    }, [selectedMeshId, selectedMesh]);

    useEffect(() => {
        if(textures) {
            setSelectedTexture(textures[0]);
        }
    }, [textures])

    const getImage = () => {
        const texture = selectedMesh.material.map;

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = texture.image.width;
        canvas.height = texture.image.height;
        ctx.drawImage(texture.image, 0, 0);
        
        return canvas.toDataURL();
    }

    const selectBackground = (background) => {
        setSelectedBackground(background);
    };

    const selectTexture = (texture) => {
        setSelectedTexture(texture);

        if (!texture) {
            return;
        }

        const url = texture;
        const objectID = url.split("/").pop().split(".")[0];

	console.log('from url', objectID);
	console.log(objects);

        if (objectID) {
const selectedObject = objects.find(
                (o) => String(o.object_id) === String(objectID)
            );

		console.log('selected', selectedObject);

            if (selectedObject) {
                setReference(selectedObject);
            } else {
		setReference(null);
		}
        }
    };

    const [currentTransition, setCurrentTransition] = useState({ textures: 0, backgrounds: 0 });

    const navigateUp = (navigateFor) => {
        if (currentTransition[navigateFor] >= 0) {
            return;
        }

        const transitionObj = {
            ...currentTransition
        };

        transitionObj[navigateFor] = currentTransition[navigateFor] + (previewBoxHeight + previewBoxMargin);

        setCurrentTransition(transitionObj);
    };

    const navigateDown = (navigateFor) => {
        if (Math.abs(currentTransition[navigateFor]) >= (navigateFor === 'textures' ? textures.length : backgrounds.length) * previewBoxHeight - previewBoxHeight) {
            return;
        }

        const transitionObj = {
            ...currentTransition
        };

        transitionObj[navigateFor] = currentTransition[navigateFor] - (previewBoxHeight + previewBoxMargin);

        setCurrentTransition(transitionObj);
    };

    const navigateToByIndex = (navigateFor, index) => {
        const transitionObj = {
            ...currentTransition
        };

        const previewBoxSize = previewBoxHeight + previewBoxMargin;

        transitionObj[navigateFor] = Math.abs(((index + 1) * previewBoxSize) - previewBoxSize) * -1;

        setCurrentTransition(transitionObj);
    };

    const renderBackgrounds = () => {
        if (!project) {
            return;
        }

        return (
            <div style={{ display: 'flex', justifyContent: 'center', height: '100%' }}>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', borderRadius: '6px', height: '385px', background: theme.palette.backgroundsPreview.background }}>
                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, maxWidth: '70px', borderRadius: '6px', overflowY: 'auto', paddingTop: '5px', paddingLeft: '5px', paddingBottom: '5px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => navigateUp('backgrounds')}>
                            <div style={{ width: '70px', height: '35px', overflow: 'hidden', border: '1px solid', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', backgroundColor: '#40b2e0', color: '#FFF', cursor: 'pointer', userSelect: 'none' }}>
                                <ArrowDropUpOutlinedIcon style={{ fontSize: '55px' }}></ArrowDropUpOutlinedIcon>
                            </div>
                        </div>
                        <div style={{ overflow: 'hidden', flex: 1, marginTop: '5px', marginBottom: '5px' }}>
                            <div style={{ transform: `translateY(${currentTransition.backgrounds}px)` }}>
                                {backgrounds?.map((background) => (
                                    <div key={background.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '6px', border: background.id === selectedBackground?.id ? '1px solid #40B2E0' : 'none', padding: '5px', height: previewBoxHeight + 'px', marginBottom: previewBoxMargin + 'px', cursor: 'pointer', userSelect: 'none' }} onClick={() => selectBackground(background)}>
                                        <img src={background.image} style={{ width: '100%', height: '100%', borderRadius: '6px' }} />
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => navigateDown('backgrounds')}>
                            <div style={{ width: '70px', height: '35px', overflow: 'hidden', border: '1px solid', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', backgroundColor: '#40b2e0', color: '#FFF', cursor: 'pointer', userSelect: 'none' }}>
                                <ArrowDropDownOutlinedIcon style={{ fontSize: '55px' }}></ArrowDropDownOutlinedIcon>
                            </div>
                        </div>
                    </div>
                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1, height: '100%', padding: '5px' }}>
                        <img src={selectedBackground?.image} style={{ position: 'relative', width: '100%', height: '100%', zIndex: 1, borderRadius: '6px' }} />
                        {selectedTexture ? <img src={selectedTexture} style={{ position: 'absolute', maxWidth: '100%', maxHeight: '100%', padding: '20%', zIndex: 2, borderRadius: '6px' }} /> : ''}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, maxWidth: '70px', borderRadius: '6px', overflowY: 'auto', paddingTop: '5px', paddingRight: '5px', paddingBottom: '5px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => navigateUp('textures')}>
                            <div style={{ width: '70px', height: '35px', overflow: 'hidden', border: '1px solid', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', backgroundColor: '#40b2e0', color: '#FFF', cursor: 'pointer', userSelect: 'none' }}>
                                <ArrowDropUpOutlinedIcon style={{ fontSize: '55px' }}></ArrowDropUpOutlinedIcon>
                            </div>
                        </div>
                        <div style={{ overflow: 'hidden', flex: 1, marginTop: '5px', marginBottom: '5px' }}>
                            <div style={{ transform: `translateY(${currentTransition.textures}px)` }}>
                                {textures?.map((texture) => (
                                    <div key={texture.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '6px', border: texture === selectedTexture ? '1px solid #40B2E0' : 'none', padding: '5px', height: previewBoxHeight + 'px', marginBottom: previewBoxMargin + 'px', cursor: 'pointer', userSelect: 'none' }} onClick={() => selectTexture(texture)}>
                                        <img src={texture} style={{ maxWidth: '100%', maxHeight: '100%', backgroundSize: 'cover', backgroundPosition: 'center center' }} />
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => navigateDown('textures')}>
                            <div style={{ width: '70px', height: '35px', overflow: 'hidden', border: '1px solid', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', backgroundColor: '#40b2e0', color: '#FFF', cursor: 'pointer', userSelect: 'none' }}>
                                <ArrowDropDownOutlinedIcon style={{ fontSize: '55px' }}></ArrowDropDownOutlinedIcon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <React.Fragment>
            {renderBackgrounds()}
        </React.Fragment>
    )
}
